import React from 'react';

interface IProps {
    label: string;
}

export const ConversationGroupHeader: React.FC<IProps> = ({ label }) => (
    <div className="chat-ai-sidebar__group-header" aria-label={label}>
        <span className="chat-ai-sidebar__group-header-label">{label}</span>
        <span className="chat-ai-sidebar__group-header-rule" aria-hidden />
    </div>
);
